import { useEffect } from 'react';
import { Row, Col, Spin } from 'antd';
import { useAuthN } from '../../authN/useAuthN';
import { useNav } from '../../routing/useNav';

const ReturnToApp = () => {
	const { isAuthenticated, isInProgress, signIn } = useAuthN();

	const nav = useNav();

	useEffect(() => {
		if (isAuthenticated) {
			nav.goHome();
		} else if (!isInProgress) {
			signIn();
		}
	}, [isAuthenticated]);

	//-- Using a spinner here prevents a flash of the sign in page when auto signing in
	return (
		<Row justify='center' align='middle' style={{ height: '100%' }}>
			<Col>
				<Spin />
			</Col>
		</Row>
	);
};

export default ReturnToApp;
